<template>
  <div>
    <form>
      <b-card
        style="
          border: solid 1px #f5a623;
          padding: 0px;
          width: 100%;
          margin-left: 0rem !important;
          margin-right: 1rem !important;
          background-color: #ebedef !important;
        "
      >
        <div class="row">
          <div class="col-12">
            <select
              class="form-control"
              id="SelectRegion"
              required
              v-model="selected_societe"
              @change="fetch_get_matrs(selected_societe)"
            >
              <option value disabled selected>Societé</option>
              <option
                v-for="(annUsers, index) in all_societe"
                :value="annUsers.id"
                :key="'i' + index"
              >
                {{ annUsers.nom }}
              </option>
            </select>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <!-- <label>Nom</label> -->
              <input
                aria-label="label"
                type="text"
                class="form-control personalise"
                placeholder="Matricule *"
                v-model="matr"
              />
            </div>
          </div>
        </div>
        <CButton
          @click.prevent="create"
          type="submit"
          size="sm"
          color="info"
          style="border-radius: 24px; margin-left: 22px; height: 36px"
        >
          Ajouter matricule</CButton
        >
      </b-card>
    </form>
  </div>
</template>


<style lang="scss" scoped>
.md-card {
  width: 98%;
  margin: 4px;
  margin-left: 11px;
  display: inline-block;
  vertical-align: top;
}
</style>

<script>
import Vue from "vue";

import { apiDomain } from "../../config";
import axios from "axios";
export default {
  components: {},
  name: "register",
  data() {
    return {
      selected_societe: "",
      all_societe: [],
      //somme: "100",
      initial_qts: "",
      nom_chouffeur: "",
      matr: "",
      nb_klm: "",
      numero_sach: "",

      date: new Date().toISOString().split("T")[0],
      ajouter_par: "azouz",

      showPart1: true,
      showPart2: false,
      showPart3: false,
      showPart4: false,
      showPart5: false,

      /*  {
          titre: "",
        
          description: ""
        } */
      programmes: [],
      details: [],
      sCats33: [],
      qts: [
        /*  {
          qts: "1",
        }, */
      ],
      detail_services: {},

      show: false,
      showdetailleModale: false,
      detaille: {
        titre: "",

        description: "",
      },
      index: -1,

      /* -------------------- */

      showdetailleModaleDetails: false,

      detailleDetails: {
        detail_services_id: "",
      },
      /* ----------------------- */
      showdetailleModaleQts: false,

      detailleQts: {
        qts: "",
      },
      /*  */

      Cats: [],
      sCats: [],
      sCats3: [],

      categorie_id: null,
      text_null: "null",
    };
  },
  created() {
    this.get_societe_services();
    this.getCategories();
    if (
      showPart1 == false &&
      showPart2 == false &&
      showPart3 == true &&
      showPart4 == false &&
      showPart5 == false
    ) {
      this.fetchCatTypes3();
    }
  },
  mounted() {},
  computed: {
    somme: function () {
      var sum = 0;
      for (var i = 0; i < this.all_service.length; i++) {
        sum += this.all_service[i].prix * this.all_service[i].qts;
      }
      return sum;
    },

    somme_fr() {
      const { NumberToLetter } = require("convertir-nombre-lettre");
      return NumberToLetter(this.somme);
    },

    all_service() {
      let arr1 = this.programmes;

      let arr2 = this.sCats3;
      let arr4 = this.qts;

      let arr3 = arr1.map((item, i) =>
        Object.assign({}, item, arr2[i], arr4[i])
      );

      console.log(arr3);
      return arr3;
    },
  },
  methods: {
    Remove(file, index) {
      this.programmes.splice(index, 1);
      this.sCats3.splice(index, 1);
      this.qts.splice(index, 1);
    },

    create(e) {
      let formData = new FormData();
      formData.append("matricule", this.matr);

      formData.append("societe_id", this.selected_societe);

      axios
        .post(`${apiDomain}/api/ajout_matr`, formData)

        .then((res) => {
          this.$noty.success("Matricule Ajouter avec Succès ! ");

        //  this.$router.push("/");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },

    addNewProgramme: function () {
      this.programmes.push(Vue.util.extend({}, this.detaille));
    },

    onSelect(Sous_categorie) {
      this.programmes.push(Sous_categorie);
      this.sCats3.push(detail);

      console.log(this.programmes);
    },
    //detaile push
    onSelectDetails(detail) {
      this.sCats3.push(detail);
      this.qts.push(detail);

      console.log(this.sCats3);
    },

    //Qts push
    onSelectQts(initial_qts) {
      this.qts.push(initial_qts);
      //console.log(this.qts);
      // this.programmes.push(Vue.util.extend({}, this.detaille));
    },

    addNewQTS: function () {
      this.qts.push(Vue.util.extend({}, this.qt));
    },

    showEditModalDetails(detail, index) {
      let obj = {
        // id: Sous_categorie.id,
        detail_services_id: detail.Type,
      };
      this.detailleDetails = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetailleDetails(detail) {
      this.detailleDetails = detail;
      this.showdetailleModaleDetails = true;
    },

    /* fin detail push */
    showEditModal(Sous_categorie, index) {
      let obj = {
        // id: Sous_categorie.id,
        titre: Sous_categorie.titre_sc,
        description: Sous_categorie.image_sc,
      };
      this.detaille = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetaille(Sous_categorie) {
      this.detaille = Sous_categorie;
      this.showdetailleModale = true;
    },

    //qts
    /*  showEditModalDetails(qt, index) {
      let obj = {
        // id: Sous_categorie.id,
        qts: qt.qts,
      };
      this.detailleQts = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetailleDetails(qt) {
      this.detailleDetails = qt;
      this.showdetailleModaleQts = true;
    }, */

    getCategories() {
      axios
        .get(`${apiDomain}/api/listeCtegoriesSubCategg`)

        .then((res) => {
          /*        this.showPart1 = true;
        this.showPart2 = true; */
          this.Cats = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },

    /*   fetchCatTypes3() {
      axios
        .get(`${apiDomain}/api/fetchCatTypes3`)

        .then((res) => {
          this.showPart3 = false;
          this.showPart4 = true;
          this.detail_services = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    }, */

    fetchCatTypes3(id) {
      axios.get(`${apiDomain}/api/getTypes3/${id}`).then(({ data }) => {
        this.showPart3 = false;
        this.showPart4 = true;
        this.sCats33 = data.sous_cat;
        // this.nameFatherCat = data.cat.titreCategorie;
      });
    },

    get_societe_services() {
      axios
        .get(`${apiDomain}/api/all_societe`)

        .then((res) => {
          this.all_societe = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },

    fetchCatTypes(id) {
      axios.get(`${apiDomain}/api/getTypes/${id}`).then(({ data }) => {
        this.showPart1 = false;
        this.showPart2 = false;
        this.showPart3 = true;
        this.sCats = data.sous_cat;
        // this.nameFatherCat = data.cat.titreCategorie;
      });
    },
  },
};
</script>

<style lang="scss" >
.glow-on-hover {
  width: 90px;
  height: 76px;
  border: none;
  outline: none;
  color: #fff;
  background: #24b2dc;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
}

.glow-on-hover:before {
  content: "";
  /*   background: #20b3b3;
  color: #fff; */
  background: linear-gradient(
    45deg,
    #ff0000,
    #ff7300,
    #fffb00,
    #48ff00,
    #00ffd5,
    #002bff,
    #7a00ff,
    #ff00c8,
    #ff0000
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #de8e15;
  left: 0;
  top: 0;
  border-radius: 10px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}

/* ***** */
.custom-input {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.4em;
  background-color: #341677;
}
</style>